import { render, staticRenderFns } from "./CompanyTransactionPayoutCard.vue?vue&type=template&id=2ae6ac4c&scoped=true"
import script from "./CompanyTransactionPayoutCard.vue?vue&type=script&lang=js"
export * from "./CompanyTransactionPayoutCard.vue?vue&type=script&lang=js"
import style0 from "./CompanyTransactionPayoutCard.vue?vue&type=style&index=0&id=2ae6ac4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae6ac4c",
  null
  
)

export default component.exports